export default {"src":"https://fishbrain.com/_next/static/media/northCarolina.7a3be6c8.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};